import React, { FunctionComponent } from 'react'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'

import { createCampaign, campaignsList } from 'Router/routes'
import { APP } from 'Configs/App'
import { WhiteGreyBtnWithPlus } from 'Stories/Button/Button.stories'
import {
  EmptyCampaignsContent,
  EmptyCampaignsContentWrapper,
} from 'Containers/CampaignsList/components/styles'

type CampaignEmptyPageProps = {
  spotifyAccessToken: string
}

const CampaignEmptyPage: FunctionComponent<CampaignEmptyPageProps> = ({
  spotifyAccessToken,
}) => {
  const { t } = useTranslation()
  const history = useHistory()

  const checkAccessToken = () => {
    if (spotifyAccessToken) {
      history.push(`${campaignsList}${createCampaign}`)
    } else {
      window.location.href = APP.SPOTIFY_AUTH_API as string
    }
  }

  return (
    <EmptyCampaignsContentWrapper>
      <EmptyCampaignsContent>
        <span>
          <p>{t('campaignsPage.getStarted')}</p>
        </span>
        <WhiteGreyBtnWithPlus color="white" onClick={checkAccessToken}>
          + {t('campaignsPage.createNewCampaign')}
        </WhiteGreyBtnWithPlus>
      </EmptyCampaignsContent>
    </EmptyCampaignsContentWrapper>
  )
}

export default CampaignEmptyPage
